export default "__VITE_ASSET__BhNwJkMI__"